import React, { FC } from 'react';
import classNames from 'classnames';
import { useLogout } from '../../../../hooks/Authorization/useLogout';

import classes from './ModalLogout.module.scss';
import modalBase from '../../../ModalBase/ModalBase.module.scss';

type ModalLogout = {
  activeLogout: boolean;
  setActiveLogout: (value: boolean) => void;
  setIsAuthenticated: (status: boolean) => void;
  setWorkPlaceSelected?: (status: boolean) => void;
};

const ModalLogout: FC<ModalLogout> = ({
  activeLogout,
  setActiveLogout,
  setIsAuthenticated,
  setWorkPlaceSelected
}) => {
  const { logout } = useLogout(setIsAuthenticated);
  const handleClickConfirm = () => {
    logout();
    setActiveLogout(false);
    setWorkPlaceSelected && setWorkPlaceSelected(false);
  };
  const handleClickCancel = () => {
    setActiveLogout(false);
  };
  return (
    <div className={classNames(modalBase.modal, { [modalBase.active]: activeLogout })}>
      <div className={classNames(modalBase.container, classes.modalContainer)}>
        <h2 className={modalBase.title}>Выйти из системы?</h2>
        <div className={classes.btnContainer}>
          <button
            className={classNames(classes.btnCansel, classes.btn)}
            onClick={handleClickCancel}>
            нет
          </button>
          <button
            className={classNames(classes.btnConfirm, classes.btn)}
            onClick={handleClickConfirm}>
            да
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalLogout;
